/* Famgraving — Home nueva: reveals, counters, FAQ, sticky bar, signup.
   Lo que ya está en pantalla al cargar nunca se esconde (no retrasa el hero). */
(function () {
  if (window.__fghInit) return;
  window.__fghInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = !reduced && 'IntersectionObserver' in window;

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 800) && r.bottom > 0;
  }

  function fmt(n) { return n.toLocaleString('en-US'); }

  function runCounter(el) {
    if (el.dataset.fghDone) return;
    el.dataset.fghDone = '1';
    var target = parseInt(el.dataset.fghCount, 10) || 0;
    var suffix = el.dataset.fghSuffix || '';
    if (!motion) { el.textContent = fmt(target) + suffix; return; }
    var t0 = performance.now(), dur = 1500;
    (function tick(t) {
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * e)) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  function init() {
    var roots = document.querySelectorAll('.fgh');
    if (!roots.length) return;

    // Stagger siblings: each reveal gets a delay based on its position among siblings.
    document.querySelectorAll('.fgh [data-fgh-reveal]').forEach(function (el) {
      var parent = el.parentElement;
      var step = parseInt((parent && parent.dataset.fghStagger) || '90', 10);
      var sibs = parent ? Array.prototype.filter.call(parent.children, function (c) { return c.hasAttribute('data-fgh-reveal'); }) : [el];
      var idx = sibs.indexOf(el);
      if (sibs.length > 1) el.style.setProperty('--fgh-delay', Math.min(idx, 7) * step + 'ms');
    });

    var targets = document.querySelectorAll('.fgh [data-fgh-reveal], .fgh .fgh__rule, .fgh .fgh-zoom, .fgh [data-fgh-count]');

    if (!motion) {
      targets.forEach(function (el) { el.classList.add('is-in'); if (el.dataset.fghCount) runCounter(el); });
    } else {
      // Mark what is already visible BEFORE enabling motion so nothing above the fold flashes.
      targets.forEach(function (el) {
        if (onScreen(el) && !el.classList.contains('fgh-zoom')) {
          el.classList.add('is-in');
          if (el.dataset.fghCount) runCounter(el);
        }
      });
      document.documentElement.classList.add('fgh-motion');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          if (en.target.dataset.fghCount) runCounter(en.target);
          io.unobserve(en.target);
        });
      }, { threshold: 0.08 });
      targets.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
      // Hero photo soft zoom runs once after first paint.
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        document.querySelectorAll('.fgh .fgh-zoom').forEach(function (el) { el.classList.add('is-in'); });
      }); });
      document.querySelectorAll('.fgh-video').forEach(function (el) { el.classList.add('is-motion'); });
      // Safety net: never leave content hidden if the observer does not fire.
      setTimeout(function () {
        targets.forEach(function (el) {
          if (el.getBoundingClientRect().top < (window.innerHeight || 800) + 200) {
            el.classList.add('is-in');
            if (el.dataset.fghCount) runCounter(el);
          }
        });
      }, 1500);
    }

    // FAQ accordion
    document.querySelectorAll('.fgh-faq__q').forEach(function (btn) {
      if (btn.dataset.fghBound) return;
      btn.dataset.fghBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.fgh-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Sticky mobile CTA bar: appears after scrolling past the hero.
    var sticky = document.querySelector('.fgh-sticky');
    var hero = document.querySelector('.fgh-hero');
    if (sticky && hero && !sticky.dataset.fghBound) {
      sticky.dataset.fghBound = '1';
      document.body.classList.add('fgh-has-sticky');
      var onScroll = function () {
        var past = hero.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', past);
        document.body.classList.toggle('fgh-sticky-on', past && window.innerWidth < 760);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Anti-bot (19-oct-2026): bots were filling this form with fake emails. A submit is ignored
    // (shows the normal success message, sends nothing) if the hidden trap field is filled, if it
    // comes less than 3 s after page load, without any real key/tap/mouse on the page, or from an
    // ancient/fake browser (MSIE, Camino, PPC Mac, quoted user agent: what the 127 bot signups of 5–19 oct used).
    window.fgBotGuard = window.fgBotGuard || (function () {
      var t0 = Date.now(), human = false;
      ['keydown', 'pointerdown', 'touchstart', 'mousemove'].forEach(function (ev) {
        window.addEventListener(ev, function () { human = true; }, { passive: true, once: true });
      });
      return {
        arm: function (form) {
          if (form.querySelector('input[name="fg_website"]')) return;
          var hp = document.createElement('input');
          hp.type = 'text'; hp.name = 'fg_website'; hp.tabIndex = -1; hp.autocomplete = 'off';
          hp.setAttribute('aria-hidden', 'true');
          hp.style.cssText = 'position:absolute!important;left:-9999px!important;width:1px;height:1px;opacity:0';
          form.appendChild(hp);
        },
        isBot: function (form) {
          var hp = form.querySelector('input[name="fg_website"]');
          return (hp && hp.value) || Date.now() - t0 < 3000 || !human ||
            /^\"|MSIE |Trident\/|BonEcho|Camino|PPC|Amiga|Beonex|Arora|AOL \d|Windows NT 5\.|WinNT|AppleWebKit\/(4\d\d|5[0-2]\d)[.+]|Firefox\/[1-3]?\d\.|rv:1\./.test(navigator.userAgent);
        }
      };
    })();

    // Email signup → Klaviyo list (same list as the 10% popup, so the Welcome Series sends the code).
    document.querySelectorAll('.fgh-signup__form').forEach(function (form) {
      if (form.dataset.fghBound) return;
      form.dataset.fghBound = '1';
      fgBotGuard.arm(form);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = form.querySelector('.fgh-signup__msg');
        var btn = form.querySelector('button');
        var email = (form.querySelector('input[type="email"]').value || '').trim();
        var company = form.dataset.company, list = form.dataset.list;
        var typeEl = form.querySelector('input[name="customer_type"]:checked');
        if (!email) return;
        if (!typeEl) { msg.classList.add('is-error'); msg.textContent = 'Please choose one: real estate agent or business.'; return; }
        if (fgBotGuard.isBot(form)) { form.querySelector('input[type="email"]').value = ''; typeEl.checked = false; msg.textContent = form.dataset.success || 'Check your inbox — your code is on its way.'; return; }
        btn.disabled = true;
        msg.classList.remove('is-error');
        msg.textContent = '';
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Home page signup',
                profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Customer Type': typeEl.value } } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          form.querySelector('input[type="email"]').value = '';
          typeEl.checked = false;
          msg.textContent = form.dataset.success || 'Check your inbox — your code is on its way.';
        }).catch(function () {
          msg.classList.add('is-error');
          msg.textContent = 'Something went wrong. Please try again.';
        }).then(function () { btn.disabled = false; });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // About page: hero lines, parallax, press tilt, map pin, timeline line, team tap.
  function initAbout() {
    var lines = document.querySelectorAll('.fgh [data-fgh-line]');
    lines.forEach(function (el, i) {
      el.style.setProperty('--fgh-delay', (i * 110) + 'ms');
      if (!motion) el.classList.add('is-in');
    });
    if (motion && lines.length) {
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        lines.forEach(function (el) { el.classList.add('is-in'); });
      }); });
    }
    var extras = document.querySelectorAll('.fgh [data-fgh-tilt], .fgh [data-fgh-pin], .fgh [data-fgh-grow]');
    if (!motion) { extras.forEach(function (el) { el.classList.add('is-in'); }); }
    else {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          setTimeout(function () { el.classList.add('is-in'); }, el.hasAttribute('data-fgh-tilt') ? 300 : 0);
          io2.unobserve(el);
        });
      }, { threshold: 0.15 });
      extras.forEach(function (el) { io2.observe(el); });
    }
    var wraps = document.querySelectorAll('.fgh [data-fgh-parallax-wrap]');
    if (motion && wraps.length) {
      var ticking = false;
      var run = function () {
        var vh = window.innerHeight || 800;
        wraps.forEach(function (w) {
          var r = w.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var off = ((r.top + r.height / 2) - vh / 2) * -0.08;
          w.style.setProperty('--fgh-par', off.toFixed(1) + 'px');
        });
        ticking = false;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
      run();
    }
    document.querySelectorAll('.fgh-team__card').forEach(function (c) {
      if (c.dataset.fghBound) return;
      c.dataset.fghBound = '1';
      c.addEventListener('click', function () { c.classList.toggle('is-open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAbout);
  else initAbout();

  // Aviso de compras reales: lee la lista que publica el VPS y la va mostrando.
  function initRecent() {
    var box = document.querySelector('.fgh-recent');
    var dataEl = document.getElementById('fgh-recent-data');
    if (!box || !dataEl || box.dataset.fghBound) return;
    box.dataset.fghBound = '1';
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var now = Date.now() / 1000, maxAge = (parseInt(box.dataset.maxdays, 10) || 7) * 86400;
    var items = (data.items || []).filter(function (x) { return now - x.ts < maxAge; });
    if (!items.length) return;
    var KEY = 'fghRecentClosed';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var first = (parseInt(box.dataset.first, 10) || 8) * 1000;
    var show = (parseInt(box.dataset.show, 10) || 5) * 1000;
    var gap = (parseInt(box.dataset.gap, 10) || 18) * 1000;
    var max = parseInt(box.dataset.max, 10) || 4;
    var label = box.dataset.label || 'was just ordered';
    var i = 0, shown = 0, stopped = false;
    function ago(ts) {
      var s = Math.max(60, now - ts), m = Math.round(s / 60), h = Math.round(s / 3600), d = Math.round(s / 86400);
      if (m < 60) return m + (m === 1 ? ' minute ago' : ' minutes ago');
      if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
      return d + (d === 1 ? ' day ago' : ' days ago');
    }
    function next() {
      if (stopped || shown >= max) return;
      var it = items[i % items.length]; i++; shown++;
      // Famgraving.com trae primer nombre + estado; Etsy/Amazon/Faire nunca traen datos del comprador.
      // No se dice de qué tienda vino (decisión de Maria).
      box.querySelector('.fgh-recent__title').textContent = it.n
        ? it.n + (it.s ? ' from ' + it.s : '') + ' bought ' + it.t
        : it.t + ' ' + label;
      box.querySelector('.fgh-recent__meta').textContent = ago(it.ts);
      box.classList.add('is-on');
      setTimeout(function () { box.classList.remove('is-on'); setTimeout(next, gap); }, show);
    }
    box.querySelector('.fgh-recent__close').addEventListener('click', function () {
      stopped = true; box.classList.remove('is-on');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
    setTimeout(next, first);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRecent);
  else initRecent();

  // Theme editor: re-run when a section is added or changed (bindings are idempotent).
  document.addEventListener('shopify:section:load', init);
})();
